import * as tslib_1 from "tslib";
import { AbstractBase } from '../../../core/helpers/abstract-base';
/**
 * Base class for the columns in a ListComponent.
 * @see ColumnContainerComponent.
 */
var ColumnBase = /** @class */ (function (_super) {
    tslib_1.__extends(ColumnBase, _super);
    /**
     * Constructs a ColumnBase
     * @param provider Provides the configuration information for the column.
     */
    function ColumnBase(provider, changeDetector) {
        var _this = _super.call(this) || this;
        _this.provider = provider;
        _this.changeDetector = changeDetector;
        /**
         * Gets, sets the breeze subscription handle of the entity property changed event.
         * Is used to optimise change detection.
         * @protected
         * @type {number}
         */
        _this.propertyChangedSubscription = undefined;
        return _this;
    }
    /** Lifecycle hook that is called after a component's view has been fully initialized. */
    ColumnBase.prototype.ngAfterViewInit = function () {
        this.startOptimisedChangeDetection();
    };
    /**
     * Called just before Angular destroys the component.
     */
    ColumnBase.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.propertyChangedSubscription && this.provider.entity) {
            var entity = this.provider.entity;
            entity.entityAspect.propertyChanged.unsubscribe(this.propertyChangedSubscription);
        }
    };
    /**
     * Tries to start an optimised change detection based upon entiy property changes.
     * The component will fallback on angular change detection when failing.
     * @protected
     */
    ColumnBase.prototype.startOptimisedChangeDetection = function () {
        var _this = this;
        if (this.provider.entity) {
            this.changeDetector.detach();
            var entity = this.provider.entity;
            this.propertyChangedSubscription = entity.entityAspect.propertyChanged.subscribe(function (data) {
                _this.changeDetector.detectChanges();
            });
        }
    };
    return ColumnBase;
}(AbstractBase));
export { ColumnBase };
